const PurchaseOrders = () => import("Modules/supply_chain/purchase_orders/views/PurchaseOrders");
const PurchaseOrdersForm = () => import("Modules/supply_chain/purchase_orders/views/PurchaseOrdersForm");

export default {
    children: [
        {
            path: "purchasing/purchase_orders",
            name: "purchase_orders",
            component: PurchaseOrders,
            meta: {
                requiresAuth: true,
                title: "lang.purchase_orders",
                restrict_by_login_type: ["employee", "customer", "vendor"],
                restrict_by_permission: ["purchase_orders.read"],
            },
        },
        {
            path: "purchasing/purchase_order/:id?",
            name: "purchase_order",
            component: PurchaseOrdersForm,
            meta: {
                requiresAuth: true,
                title: "lang.purchase_orders",
                restrict_by_login_type: ["employee", "customer", "vendor"],
                restrict_by_permission: ["purchase_orders.read"],
            },
        },
    ],
};
